import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpErrorResponse,
  HttpBackend,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import { DialogueVo } from "../data/dialogue/dialoguevo";
import { UserSessionService } from "./user-session.service";
import { SystemService } from "./system.service";
import { ModalService } from "./modal-service";
import { AuthService } from "./auth.service";
import { AdminAuthGuard } from "./admin-auth.guard";
import { UserAuthGuard } from "./user-auth.guard";
import { UserSessionVo } from "../data/user-session-vo";
const CHECK_INTERVAL = 30000; // in ms

@Injectable({
  providedIn: "root",
})
export class UserSessionPingService {
  refreshIntervalId;
  inPing = false;
  constructor(
    private http: HttpClient,
    private modalService: ModalService,
    private authService: AuthService,
    private adminAuthGuard: AdminAuthGuard,
    private userAuthGuard: UserAuthGuard,
    private systemService: SystemService
  ) {}

  initInterval() {
    let turnOn = 1; // set to 1 for prod build or local
    if (turnOn === 1) {
      this.refreshIntervalId = setInterval(() => {
        this.checkStatus();
      }, CHECK_INTERVAL);
    }
  }

  checkStatus() {
    if (this.inPing === false) {
      if (
        this.systemService !== undefined &&
        this.systemService !== null &&
        this.systemService.userSessionVo !== null &&
        this.systemService.userSessionVo.userId !== undefined
      ) {
        let dbName = this.systemService.userSessionVo.siteDatabaseName;
        let userId = this.systemService.userSessionVo.userId;
        //console.log('checkStatus() dbname ' + dbName);
        //console.log('checkStatus() userId ' + userId);
        this.inPing = true;
        this.http
          .get<DialogueVo>(
            `/service/sessions/dbs/${dbName}/users/${userId}/ping`
          )
          .subscribe((data) => {
            this.inPing = false;
            // console.log('ping ' + data['courseOfActionVo']['coaName']);
            if (data["courseOfActionVo"]["coaName"] === "Logged Out") {
              this.systemService.userLoggedOut = true;
              this.modalService.open("user-disconnected");
              clearInterval(this.refreshIntervalId);
              this.systemService.userSessionVo = <UserSessionVo>{};
              this.systemService.setUsername("");
              this.systemService.setdbname("");
              this.adminAuthGuard.reset();
              this.userAuthGuard.reset();
              localStorage.clear();
            }
          });
      } else {
        clearInterval(this.refreshIntervalId);
        this.systemService.userSessionVo = <UserSessionVo>{};
        this.systemService.setUsername("");
        this.systemService.setdbname("");
        this.adminAuthGuard.reset();
        this.userAuthGuard.reset();
        localStorage.clear();
      }
    }
  }

  disable(toggle) {
    if (toggle) {
      clearInterval(this.refreshIntervalId);
    } else {
      this.initInterval();
    }
  }
}
